'use client';
var classes = {"root":"m_dc6f14e2"};

export { classes as default };
//# sourceMappingURL=Kbd.module.css.mjs.map
